import { Text } from "@paguelofacil/pf-components";

import { extractInitialsFromName } from "../../utils/helpers";

import "./style.scss";

export const AvatarDefault = ({ name, padding, fontSize }) => {
    return (
        <div className="default-avatar" style={{ padding }}>
            <Text color="#ffffff" variant="body6" style={{ fontSize }}>
                {extractInitialsFromName(name)}
            </Text>
        </div>
    );
};
